/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Progress_Aria_LabelInputs */

const en_scene_change_detection_progress_aria_label = /** @type {(inputs: Scene_Change_Detection_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shot change detection progress`)
};

const fr_scene_change_detection_progress_aria_label = /** @type {(inputs: Scene_Change_Detection_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progression de la detection de changement de plan`)
};

const de_scene_change_detection_progress_aria_label = /** @type {(inputs: Scene_Change_Detection_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortschritt der Schussänderungserkennung`)
};

const it_scene_change_detection_progress_aria_label = /** @type {(inputs: Scene_Change_Detection_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresso nel rilevamento del cambio di tiro`)
};

const ru_scene_change_detection_progress_aria_label = /** @type {(inputs: Scene_Change_Detection_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`прогресс обнаружения смены кадра`)
};

const es_scene_change_detection_progress_aria_label = /** @type {(inputs: Scene_Change_Detection_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progreso en la detección de cambios de toma`)
};

const zh_cn2_scene_change_detection_progress_aria_label = /** @type {(inputs: Scene_Change_Detection_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`投篮变化检测进度`)
};

const ja_scene_change_detection_progress_aria_label = /** @type {(inputs: Scene_Change_Detection_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショット変更検出の進行状況`)
};

const hi_scene_change_detection_progress_aria_label = /** @type {(inputs: Scene_Change_Detection_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट परिवर्तन पहचान प्रगति`)
};

const pt_pt2_scene_change_detection_progress_aria_label = /** @type {(inputs: Scene_Change_Detection_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresso da detecção de mudança de tiro`)
};

/**
* | output |
* | --- |
* | "Shot change detection progress" |
*
* @param {Scene_Change_Detection_Progress_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_progress_aria_label = /** @type {((inputs?: Scene_Change_Detection_Progress_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Progress_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_change_detection_progress_aria_label(inputs)
	if (locale === "de") return de_scene_change_detection_progress_aria_label(inputs)
	if (locale === "it") return it_scene_change_detection_progress_aria_label(inputs)
	if (locale === "ru") return ru_scene_change_detection_progress_aria_label(inputs)
	if (locale === "es") return es_scene_change_detection_progress_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_change_detection_progress_aria_label(inputs)
	if (locale === "ja") return ja_scene_change_detection_progress_aria_label(inputs)
	if (locale === "hi") return hi_scene_change_detection_progress_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_change_detection_progress_aria_label(inputs)
	return en_scene_change_detection_progress_aria_label(inputs)
});